import axios from 'axios'
import pascalToCamelCase from 'Services/pascalToCamelCase'

const endpoint = 'https://api.sindiconet.com.br/TiraDuvidas'

export const getCompanyAnswers = (companyId) => {
  const url = `${endpoint}/empresa/participacao/${companyId}`

  const transformResponse = [].concat(
    axios.defaults.transformResponse,
    data => pascalToCamelCase(data),
  )

  return axios.get(url, { transformResponse })
}

export default {
  getCompanyAnswers,
}